/*
 * This unpublished material is proprietary to Vaticle.
 * All rights reserved. The methods and
 * techniques described herein are considered trade secrets
 * and/or confidential. Reproduction or distribution, in whole
 * or in part, is forbidden except by express written permission
 * of Vaticle.
 */

import { Observable } from "rxjs";
import { Cluster, Server } from "../../../concept/cluster";
import { SnackbarService } from "../../../service/snackbar.service";

export type ConnectDialogData = {
    cluster$: Observable<Cluster>,
    servers$: Observable<Server[]>,
}

export enum OperatingSystem {
    MAC_X86_64 = "mac-x86_64",
    MAC_ARM64 = "mac-arm64",
    LINUX_X86_64 = "linux-x86_64",
    LINUX_ARM64 = "linux-arm64",
    WINDOWS_X86_64 = "windows-x86_64",
}

export function detectOS(): OperatingSystem {
    const userAgent = navigator.userAgent.toLowerCase();

    if (userAgent.includes('win')) {
        return OperatingSystem.WINDOWS_X86_64;
    } else if (userAgent.includes('mac')) {
        return OperatingSystem.MAC_X86_64;
    } else if (userAgent.includes('linux')) {
        return OperatingSystem.LINUX_X86_64;
    }

    return OperatingSystem.MAC_X86_64;
}

export interface ParsedVersion {
    major: number;
    minor: number;
    patch: number;
}

export function parseVersionString(version: string): ParsedVersion {
    const [major, minor, patch] = version.split(".").map(x => parseInt(x));
    return { major, minor, patch };
}

export function supportsUserPasswordReset(version: ParsedVersion): boolean {
    return version.major === 3 && version.minor >= 12;
}

export const PASSWORD_FILLER = "db_password"

export function buildConnectionString(password: string | undefined, addresses: string[], typedbVersion: ParsedVersion, clusterName: string, username = "admin") {
    const preVersion3_2_0 = typedbVersion.major < 3 || typedbVersion.minor < 2
    const scheme = preVersion3_2_0 ? "typedb-cloud" : "typedb"
    const queryParamSection = `/?name=${clusterName}` + (preVersion3_2_0 ? "&tlsEnabled=true" : "")
    return `${scheme}://${username}:${password ? encodeURIComponent(password) : `<${PASSWORD_FILLER}>`}@${addresses.join(",")}${queryParamSection}`
}

export function clusterCredentialFilename(cluster: Cluster) {
    return `typedb-cloud-credentials-${cluster.id}.txt`
}

export function copy(toCopy: string, snackbar: SnackbarService) {
    navigator.clipboard.writeText(toCopy.replaceAll('&lt;', '<').replaceAll('&gt;', '>'));
    snackbar.success("Copied", { duration: 1250 });
}
